export default __webpack_public_path__ + "static/media/library_favourites.9ecfa715.mp3";